/**
 * The access source picked in the stepper, as one Select value (TRE-2110).
 * Encoded as a string so antd's Select (grouped options, search by label)
 * can carry it; decoded back before anything is computed or sent.
 */
export type AccessSourceValue =
  | { kind: "price"; priceId: string }
  | { kind: "linked"; sourceProductId: string }
  | { kind: "manual" };

const MANUAL = "manual";

/** Row identity shared by selection, per-row exceptions and the preview lookup. */
export const importRowKey = (row: { id?: string; email: string }): string => row.id ?? row.email;

export const encodeAccessSource = (value: AccessSourceValue): string => {
  switch (value.kind) {
    case "price":
      return `price:${value.priceId}`;
    case "linked":
      return `linked:${value.sourceProductId}`;
    default:
      return MANUAL;
  }
};

export const decodeAccessSource = (encoded: string | null | undefined): AccessSourceValue | null => {
  if (!encoded) {
    return null;
  }

  if (encoded === MANUAL) {
    return { kind: "manual" };
  }

  const [kind, id] = encoded.split(":", 2);

  if (kind === "price" && id) {
    return { kind: "price", priceId: id };
  }

  if (kind === "linked" && id) {
    return { kind: "linked", sourceProductId: id };
  }

  return null;
};
